import Model from '../Model';

export default class Company extends Model {
  // eslint-disable-next-line
  resource() {
    return 'companies';
  }

  ajax() {
    return this.custom('companies/ajax').get();
  }

  sales(id, filter) {
    return this.custom(`${id}/get_sales/${filter.field}/${filter.group_by}`).get();
  }

  emails(id) {
    return this.custom(`companies/${id}/emails`).get();
  }

  articlePrices(id) {
    return this.custom(`companies/${id}/article-prices`).get();
  }

  surveyHashes(id) {
    return this.custom(`companies/${id}/survey-hashes`).get();
  }
}



// WEBPACK FOOTER //
// ./src/models/Base/Company.js